import * as React from 'react'
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
// eslint-disable-next-line import/no-internal-modules
import { DateTime } from 'luxon'
import 'react-datepicker/dist/react-datepicker.css'
import { Article } from '../articlesContainer'

interface ArticleSettingsProps {
	index: number
	active: boolean
	article: Article
	updateArticle: (art: Article, instant?: boolean) => void
	page?: 'ccp' | 'campaign'
}

const ArticleSettings: React.FunctionComponent<ArticleSettingsProps> = (props) => {
	const setMaxClicks = (e: any) => {
		let value = e.target.value.trim()
		if (!isNaN(value)) {
			value = value === '' ? null : +value
			props.updateArticle(
				{
					...props.article,
					maxClicks: value,
				},
				props.article.instant,
			)
		}
	}
	const setStartDate = (value: Date) => {
		props.updateArticle(
			{
				...props.article,
				startDate: value ? DateTime.fromJSDate(value).toFormat('yyyy-MM-dd') : undefined,
			},
			props.article.instant,
		)
	}
	const setEndDate = (value: Date) => {
		props.updateArticle(
			{
				...props.article,
				endDate: value ? DateTime.fromJSDate(value).toFormat('yyyy-MM-dd') : undefined,
			},
			props.article.instant,
		)
	}
	const rowStyle = () => {
		if (props.page === 'campaign') {
			return { marginTop: '20px', marginBottom: '10px' }
		}
		return { marginBottom: '10px' }
	}
	return (
		<Row style={rowStyle()}>
			<Col md={props.page === 'campaign' ? 3 : 4}>
				<ControlLabel>Ad Group Max. Clicks</ControlLabel>
				<FormControl
					data-test="max-clicks"
					type="text"
					value={props.article.maxClicks || ''}
					onChange={setMaxClicks}
				/>
			</Col>
			<Col md={props.page === 'campaign' ? 3 : 4} style={{ zIndex: 1000 }}>
				<ControlLabel>Ad Group Start Date</ControlLabel>
				<DatePicker
					placeholderText="From Today"
					dateFormat="dd.MM.yyyy"
					selected={
						props.article.startDate && props.article.startDate !== '0000-00-00'
							? DateTime.fromFormat(props.article.startDate, 'yyyy-MM-dd').toJSDate()
							: null
					}
					onChange={setStartDate}
					calendarStartDay={1}
					todayButton="Today"
					minDate={DateTime.now().toJSDate()}
					maxDate={
						props.article.endDate && props.article.endDate !== '0000-00-00'
							? DateTime.fromFormat(props.article.endDate, 'yyyy-MM-dd').toJSDate()
							: null
					}
					className="form-control"
					isClearable
					data-test="date-from"
				/>
			</Col>
			<Col md={props.page === 'campaign' ? 3 : 4} style={{ zIndex: 1049 }}>
				<ControlLabel>Ad Group End Date</ControlLabel>
				<DatePicker
					placeholderText="To Forever"
					dateFormat="dd.MM.yyyy"
					minDate={
						props.article.startDate && props.article.startDate !== '0000-00-00'
							? DateTime.fromFormat(props.article.startDate, 'yyyy-MM-dd').toJSDate()
							: null
					}
					onChange={setEndDate}
					calendarStartDay={1}
					todayButton="Today"
					selected={
						props.article.endDate && props.article.endDate !== '0000-00-00'
							? DateTime.fromFormat(props.article.endDate, 'yyyy-MM-dd').toJSDate()
							: null
					}
					className="form-control"
					isClearable
					data-test="date-to"
				/>
			</Col>
		</Row>
	)
}

export default ArticleSettings
